import { FilterableField } from 'module/types/filter-field/field/filterable-field';
import { CustomNodeResponseFieldValueType } from 'api/custom-section/types';
import { getFieldRenderer } from './get-cell-renderer';
import { SectionTableItem, SectionTableItemWrapper } from './section-styles';

interface TableRowProps {
  field: FilterableField;
  responsesLookup: Record<string, CustomNodeResponseFieldValueType>;
}
const TableRow = ({ field, responsesLookup }: TableRowProps) => {
  return (
    <SectionTableItemWrapper key={field.fieldId}>
      <SectionTableItem>{field.fieldLabel}</SectionTableItem>
      <SectionTableItem isValue={true}>
        {getFieldRenderer({
          field,
          value: responsesLookup[field.fieldName],
        })}
      </SectionTableItem>
    </SectionTableItemWrapper>
  );
};

interface FieldsTableProps {
  fields: FilterableField[];
  responsesLookup: Record<string, CustomNodeResponseFieldValueType>;
}
export const FieldsTable = ({ fields, responsesLookup }: FieldsTableProps) => {
  return (
    <>
      {fields.map((field) => (
        <TableRow
          key={field.fieldId}
          field={field}
          responsesLookup={responsesLookup}
        />
      ))}
    </>
  );
};
